import * as types from "../Action/type";
// when the user log in as a visitor there must be a default language . so i made this check to avoid errors . Haron .
let Language = "ar" ;
if (localStorage.getItem("Language") == "en"){
    Language = "en"
}
const initialState = {
    loading: false,
    lang:Language,
    // localStorage.getItem('Language')
}
const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_Lang_REQUEST:
            return {
                ...state,
                lang: action.payload,
                loading: false,
            };   
            
        default:
            return state;
    }
}

export default languageReducer;